import { Component, OnInit, OnChanges, Input, SimpleChanges } from '@angular/core';
import { SellerApiService } from '../../../service/seller-api.service';

@Component({
  selector: 'app-common-attach-browse',
  templateUrl: './common-attach-browse.component.html',
  styleUrls: ['./common-attach-browse.component.scss']
})
export class CommonAttachBrowseComponent implements OnInit, OnChanges {

  @Input() uploadlinks: Array<any>;
  upload_links: Array<any> = [];
  constructor(private sellerService: SellerApiService) { }

  ngOnInit() {
  }
  ngOnChanges(changes: SimpleChanges) {
    this.upload_links  = [];
    if (typeof this.uploadlinks !== 'undefined') {
      if (Array.isArray(this.uploadlinks)) {
        this.upload_links = this.uploadlinks;
      } else {
        if (this.uploadlinks !== '[]') {
          this.upload_links = String(this.uploadlinks).split(',');
        }
      }
    }
  }

     // Get the Thummail
  getFileThumail(url) {
    // tslint:disable-next-line:prefer-const
    let extension = url.split('.').splice(-1)[0].toLocaleLowerCase();
    if (extension === 'jpg' || extension === 'jpeg' || extension === 'png' || extension === 'gif' || extension === 'svg') {
      return url;
    }
    let mainFileType = this.sellerService.getMainFileType(extension);
    if (mainFileType == null) {
      if (extension === 'mp3' || extension === 'ogg' || extension === 'wav'
        || extension === 'webm' || extension === 'mmf' || extension === 'm4p' || extension === 'msv') {
        mainFileType = 'audio';
      } else if (extension === 'flv'
        || extension === 'mov' || extension === 'mp4' || extension === 'avi' || extension === 'mpeg' || extension === 'wmv') {
        mainFileType = 'video';
      } else {
        mainFileType = 'other';
      }
      return this.sellerService.getThumbnailImages(mainFileType, url);
    } else {
      return this.sellerService.getThumbnailImages(mainFileType, url);
    }

  }

    getFileNameSplit(url) {
      // tslint:disable-next-line:prefer-const
      let value = url.split('_X_').pop();
      return value;
    }


}



// WEBPACK FOOTER //
// ./src/app/seller/sub-component/common/common-attach-browse/common-attach-browse.component.ts